import { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import API from "../axios";

type BannerAnimation = {
    imageUrl: string | null;
    imageUrlMobile?: string | null;
    vehicleVariantOdooId?: number | null;
    title?: string | null;
    subTitle?: string | null;
    content?: string | null;
    link: string | null;
};

type FeaturedVehicle = {
    imageUrl: string | null;
    imageUrlMobile: string | null;
    vehicleType: string | null;
    title: string | null;
    subTitle: string | null;
    link: string | null;
    link2: string | null;
};

type FeaturedService = {
    imageUrl: string | null;
    title: string | null;
    subTitle: string | null;
    link: string | null;
};

type WhatsAppChat = {
    profileUrl: string | null;
    name: string | null;
    available: boolean | null;
};

type InfoCard = {
    title: string | null;
    content: string | null;
    imageUrl: string | null;
    link: string | null;
};

const CMSEdit = () => {
    const [loading, setLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [uploadingMobile, setUploadingMobile] = useState(false);
    const [uploadingFeaturedVehicle, setUploadingFeaturedVehicle] =
        useState(false);
    const [uploadingFeaturedVehicleMobile, setUploadingFeaturedVehicleMobile] =
        useState(false);
    const [uploadingFeaturedService, setUploadingFeaturedService] =
        useState(false);
    const [uploadingInfoCard1, setUploadingInfoCard1] = useState(false);
    const [uploadingInfoCard2, setUploadingInfoCard2] = useState(false);
    const [uploadingComparePhoto, setUploadingComparePhoto] = useState(false);
    const [uploadingWhatsAppProfile, setUploadingWhatsAppProfile] =
        useState(false);
    const [cmsData, setCMSData] = useState<any>(null);

    // All CMS state
    const [bannerAnimations, setBannerAnimations] = useState<BannerAnimation[]>(
        [],
    );
    const [featuredVehicles, setFeaturedVehicles] = useState<FeaturedVehicle[]>(
        [],
    );
    const [featuredServices, setFeaturedServices] = useState<FeaturedService[]>(
        [],
    );
    const [infoCard1, setInfoCard1] = useState<InfoCard>({
        title: "",
        content: "",
        imageUrl: "",
        link: "",
    });
    const [infoCard2, setInfoCard2] = useState<InfoCard>({
        title: "",
        content: "",
        imageUrl: "",
        link: "",
    });
    const [exploreVehicleTitle, setExploreVehicleTitle] = useState("");
    const [compareTitle, setCompareTitle] = useState("");
    const [comparePhotoUrl, setComparePhotoUrl] = useState("");
    const [infoText, setInfoText] = useState("");

    // Contact info
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [facebookLink, setFacebookLink] = useState("");
    const [tiktokLink, setTiktokLink] = useState("");
    const [instagramLink, setInstagramLink] = useState("");
    const [linkedInLink, setLinkedInLink] = useState("");
    const [copyRightText, setCopyRightText] = useState("");

    // WhatsApp
    const [whatsAppTitle, setWhatsAppTitle] = useState("");
    const [whatsAppChats, setWhatsAppChats] = useState<WhatsAppChat[]>([]);

    // Modal states
    const [bannerData, setBannerData] = useState<BannerAnimation>({
        imageUrl: "",
        imageUrlMobile: "",
        vehicleVariantOdooId: null,
        title: "",
        subTitle: "",
        content: "",
        link: "",
    });
    const [featuredVehicleData, setFeaturedVehicleData] =
        useState<FeaturedVehicle>({
            imageUrl: "",
            imageUrlMobile: "",
            vehicleType: "",
            title: "",
            subTitle: "",
            link: "",
            link2: "",
        });
    const [featuredServiceData, setFeaturedServiceData] =
        useState<FeaturedService>({
            imageUrl: "",
            title: "",
            subTitle: "",
            link: "",
        });
    const [whatsAppChatData, setWhatsAppChatData] = useState<WhatsAppChat>({
        profileUrl: "",
        name: "",
        available: true,
    });

    const [editModalType, setEditModalType] = useState<
        | "banner"
        | "featuredVehicle"
        | "featuredService"
        | "testimonial"
        | "whatsAppChat"
        | null
    >(null);
    const [editModalIndex, setEditModalIndex] = useState<number | null>(null);
    const [isAddingNew, setIsAddingNew] = useState(false);

    const [isFileSizeLarge, setIsFileSizeLarge] = useState(false);
    const [isOdooIdChecked, setIsOdooIdChecked] = useState(false);
    const [isOdooIdValid, setIsOdooIdValid] = useState(true);

    const fileUploadRef = useRef<any>(null);
    const fileUploadRefMobile = useRef<any>(null);
    const fileUploadRefFeaturedVehicle = useRef<any>(null);
    const fileUploadRefFeaturedVehicleMobile = useRef<any>(null);
    const fileUploadRefFeaturedService = useRef<any>(null);
    const fileUploadRefInfoCard1 = useRef<any>(null);
    const fileUploadRefInfoCard2 = useRef<any>(null);
    const fileUploadRefComparePhoto = useRef<any>(null);
    const fileUploadRefWhatsAppProfile = useRef<any>(null);

    /* ---------------- LOAD CMS ---------------- */

    const loadLatestCMS = async () => {
        setLoading(true);

        const result: any = await API.getLatestCMS();
        const data = result.data;

        setCMSData(data);
        setBannerAnimations(data.data.bannerAnimations || []);
        setFeaturedVehicles(data.data.featuredVehicles || []);
        setFeaturedServices(data.data.featuredServices || []);
        setInfoCard1(
            data.data.infoCard1 || { title: "", content: "", imageUrl: "" },
        );
        setInfoCard2(
            data.data.infoCard2 || { title: "", content: "", imageUrl: "" },
        );
        setExploreVehicleTitle(data.data.exploreVehicleTitle || "");
        setCompareTitle(data.data.compareTitle || "");
        setComparePhotoUrl(data.data.comparePhotoUrl || "");
        setInfoText(data.data.infoText || "");

        setEmail(data.data.email || "");
        setPhoneNumber(data.data.phoneNumber || "");
        setFacebookLink(data.data.facebookLink || "");
        setTiktokLink(data.data.tiktokLink || "");
        setInstagramLink(data.data.instagramLink || "");
        setLinkedInLink(data.data.linkedInLink || "");
        setCopyRightText(data.data.copyRightText || "");

        setWhatsAppTitle(data.data.whatsApp?.title || "");
        setWhatsAppChats(data.data.whatsApp?.chats || []);

        setLoading(false);
    };

    useEffect(() => {
        loadLatestCMS();
    }, []);

    /* ---------------- SAVE CMS ---------------- */

    const handleSave = async () => {
        setSaveLoading(true);

        const payload = {
            name: cmsData?.name || "website",
            data: {
                bannerAnimations,
                featuredVehicles,
                featuredServices,
                infoCard1,
                infoCard2,
                exploreVehicleTitle,
                compareTitle,
                comparePhotoUrl,
                infoText,
                email,
                phoneNumber,
                facebookLink,
                tiktokLink,
                instagramLink,
                linkedInLink,
                whatsApp: {
                    title: whatsAppTitle,
                    chats: whatsAppChats,
                },
                copyRightText,
            },
        };

        await API.createCMS(payload);
        await loadLatestCMS();

        setSaveLoading(false);
    };

    /* ---------------- FILE UPLOAD FUNCTIONS ---------------- */

    const handleFileUpload = async (file: File, path: string) => {
        const result: any = await API.upload(file, path);
        return result.fileUrl;
    };

    const handleFileChange = async (
        e: any,
        type:
            | "banner"
            | "bannerMobile"
            | "featuredVehicle"
            | "featuredVehicleMobile"
            | "featuredService"
            | "infoCard1"
            | "infoCard2"
            | "comparePhoto"
            | "whatsAppProfile",
    ) => {
        setIsFileSizeLarge(false);
        const file = e.target.files[0];
        if (!file) return;

        if (file.size > 10 * 1024 * 1024) {
            e.target.value = "";
            setIsFileSizeLarge(true);
            return;
        }

        switch (type) {
            case "banner":
                setUploading(true);
                const bannerUrl = await handleFileUpload(
                    file,
                    "xcess.com/banner",
                );
                setBannerData({ ...bannerData, imageUrl: bannerUrl });
                setUploading(false);
                break;
            case "bannerMobile":
                setUploadingMobile(true);
                const bannerMobileUrl = await handleFileUpload(
                    file,
                    "xcess.com/banner/mobile",
                );
                setBannerData({
                    ...bannerData,
                    imageUrlMobile: bannerMobileUrl,
                });
                setUploadingMobile(false);
                break;
            case "featuredVehicle":
                setUploadingFeaturedVehicle(true);
                const vehicleUrl = await handleFileUpload(
                    file,
                    "xcess.com/featured-vehicles",
                );
                setFeaturedVehicleData({
                    ...featuredVehicleData,
                    imageUrl: vehicleUrl,
                });
                setUploadingFeaturedVehicle(false);
                break;
            case "featuredVehicleMobile":
                setUploadingFeaturedVehicleMobile(true);
                const vehicleUrlMobile = await handleFileUpload(
                    file,
                    "xcess.com/featured-vehicles",
                );
                setFeaturedVehicleData({
                    ...featuredVehicleData,
                    imageUrlMobile: vehicleUrlMobile,
                });
                setUploadingFeaturedVehicleMobile(false);
                break;
            case "featuredService":
                setUploadingFeaturedService(true);
                const serviceUrl = await handleFileUpload(
                    file,
                    "xcess.com/featured-services",
                );
                setFeaturedServiceData({
                    ...featuredServiceData,
                    imageUrl: serviceUrl,
                });
                setUploadingFeaturedService(false);
                break;
            case "infoCard1":
                setUploadingInfoCard1(true);
                const infoCard1Url = await handleFileUpload(
                    file,
                    "xcess.com/info-cards",
                );
                setInfoCard1({ ...infoCard1, imageUrl: infoCard1Url });
                setUploadingInfoCard1(false);
                break;
            case "infoCard2":
                setUploadingInfoCard2(true);
                const infoCard2Url = await handleFileUpload(
                    file,
                    "xcess.com/info-cards",
                );
                setInfoCard2({ ...infoCard2, imageUrl: infoCard2Url });
                setUploadingInfoCard2(false);
                break;
            case "comparePhoto":
                setUploadingComparePhoto(true);
                const compareUrl = await handleFileUpload(
                    file,
                    "xcess.com/compare",
                );
                setComparePhotoUrl(compareUrl);
                setUploadingComparePhoto(false);
                break;
            case "whatsAppProfile":
                setUploadingWhatsAppProfile(true);
                const profileUrl = await handleFileUpload(
                    file,
                    "xcess.com/whatsapp-profiles",
                );
                setWhatsAppChatData({ ...whatsAppChatData, profileUrl });
                setUploadingWhatsAppProfile(false);
                break;
        }
    };

    /* ---------------- MODAL HANDLERS ---------------- */

    const handleOpenBannerModal = (index: number | null = null) => {
        if (index === null) {
            // Add new banner
            setBannerData({
                imageUrl: "",
                imageUrlMobile: "",
                vehicleVariantOdooId: null,
                title: "",
                subTitle: "",
                content: "",
                link: "",
            });
            setIsAddingNew(true);
        } else {
            // Edit existing banner
            const banner = bannerAnimations[index];
            setBannerData({
                imageUrl: banner.imageUrl || "",
                imageUrlMobile: banner.imageUrlMobile || "",
                vehicleVariantOdooId: banner.vehicleVariantOdooId || null,
                title: banner.title || "",
                subTitle: banner.subTitle || "",
                content: banner.content || "",
                link: banner.link,
            });
            setIsAddingNew(false);
        }
        setEditModalType("banner");
        setEditModalIndex(index);
    };

    const handleOpenFeaturedVehicleModal = (index: number | null = null) => {
        if (index === null) {
            setFeaturedVehicleData({
                imageUrl: "",
                imageUrlMobile: "",
                vehicleType: "",
                title: "",
                subTitle: "",
                link: "",
                link2: "",
            });
            setIsAddingNew(true);
        } else {
            const vehicle = featuredVehicles[index];
            setFeaturedVehicleData({
                imageUrl: vehicle.imageUrl || "",
                imageUrlMobile: vehicle.imageUrlMobile || "",
                vehicleType: vehicle.vehicleType || "",
                title: vehicle.title || "",
                subTitle: vehicle.subTitle || "",
                link: vehicle.link || "",
                link2: vehicle.link2 || "",
            });
            setIsAddingNew(false);
        }
        setEditModalType("featuredVehicle");
        setEditModalIndex(index);
    };

    const handleOpenFeaturedServiceModal = (index: number | null = null) => {
        if (index === null) {
            setFeaturedServiceData({
                imageUrl: "",
                title: "",
                subTitle: "",
                link: "",
            });
            setIsAddingNew(true);
        } else {
            const service = featuredServices[index];
            setFeaturedServiceData({
                imageUrl: service.imageUrl || "",
                title: service.title || "",
                subTitle: service.subTitle || "",
                link: service.link || "",
            });
            setIsAddingNew(false);
        }
        setEditModalType("featuredService");
        setEditModalIndex(index);
    };

    const handleOpenWhatsAppChatModal = (index: number | null = null) => {
        if (index === null) {
            setWhatsAppChatData({
                profileUrl: "",
                name: "",
                available: true,
            });
            setIsAddingNew(true);
        } else {
            const chat = whatsAppChats[index];
            setWhatsAppChatData({
                profileUrl: chat.profileUrl || "",
                name: chat.name || "",
                available: chat.available || false,
            });
            setIsAddingNew(false);
        }
        setEditModalType("whatsAppChat");
        setEditModalIndex(index);
    };

    const handleSaveModal = () => {
        switch (editModalType) {
            case "banner":
                if (editModalIndex === null) {
                    // Add new banner
                    setBannerAnimations([...bannerAnimations, bannerData]);
                } else {
                    // Update existing banner
                    const updated = [...bannerAnimations];
                    updated[editModalIndex] = bannerData;
                    setBannerAnimations(updated);
                }
                break;
            case "featuredVehicle":
                if (editModalIndex === null) {
                    setFeaturedVehicles([
                        ...featuredVehicles,
                        featuredVehicleData,
                    ]);
                } else {
                    const updated = [...featuredVehicles];
                    updated[editModalIndex] = featuredVehicleData;
                    setFeaturedVehicles(updated);
                }
                break;
            case "featuredService":
                if (editModalIndex === null) {
                    setFeaturedServices([
                        ...featuredServices,
                        featuredServiceData,
                    ]);
                } else {
                    const updated = [...featuredServices];
                    updated[editModalIndex] = featuredServiceData;
                    setFeaturedServices(updated);
                }
                break;
            case "whatsAppChat":
                if (editModalIndex === null) {
                    setWhatsAppChats([...whatsAppChats, whatsAppChatData]);
                } else {
                    const updated = [...whatsAppChats];
                    updated[editModalIndex] = whatsAppChatData;
                    setWhatsAppChats(updated);
                }
                break;
        }
        handleCloseModal();
    };

    const handleCloseModal = () => {
        setEditModalType(null);
        setEditModalIndex(null);
        setIsAddingNew(false);
        setIsFileSizeLarge(false);
        setIsOdooIdChecked(false);
        setIsOdooIdValid(true);
    };

    /* ---------------- ODOO ID CHECK ---------------- */

    const checkIsOdooIdIsValid = async () => {
        if (!bannerData.vehicleVariantOdooId) return;

        const result = await API.getVehicleVariantWithOdooId(
            bannerData.vehicleVariantOdooId.toString(),
        );

        setIsOdooIdChecked(true);
        setIsOdooIdValid(!!result);
    };

    useEffect(() => {
        if (!bannerData.vehicleVariantOdooId) return;

        const timeout = setTimeout(() => {
            checkIsOdooIdIsValid();
        }, 1500);

        return () => clearTimeout(timeout);
    }, [bannerData.vehicleVariantOdooId]);

    /* ---------------- UI ---------------- */

    return (
        <div>
            {loading ? (
                <div className="d-flex justify-content-center my-5">
                    <div className="spinner-border" />
                </div>
            ) : (
                <Container style={{ marginTop: 100, paddingBottom: 200 }}>
                    <Row className="mb-4">
                        <Col>
                            <h1 className="fw-medium text-primary">
                                Website CMS
                            </h1>
                        </Col>
                        <Col className="text-end">
                            <button
                                className="btn btn-primary"
                                onClick={handleSave}
                                disabled={saveLoading}
                            >
                                {saveLoading ? "Saving..." : "Save"}
                            </button>
                        </Col>
                    </Row>

                    {/* ---------------- Banner Animations ---------------- */}
                    <Row className="mb-5">
                        <Col
                            xs="12"
                            className="d-flex justify-content-between align-items-center mb-3"
                        >
                            <h3 className="text-primary">Banner Animations</h3>
                            <button
                                className="btn btn-sm btn-success"
                                onClick={() => handleOpenBannerModal(null)}
                                data-bs-toggle="modal"
                                data-bs-target="#editModal"
                            >
                                + Add Banner
                            </button>
                        </Col>

                        {bannerAnimations.map((animation, index) => (
                            <Col md="4" key={index} className="mb-3">
                                <div className="card h-100">
                                    <img
                                        src={animation.imageUrl || ""}
                                        style={{
                                            height: 200,
                                            objectFit: "contain",
                                        }}
                                    />
                                    <div className="card-body">
                                        <h6>{animation.title || "No Title"}</h6>
                                        <p className="text-muted small mb-2">
                                            {animation.subTitle}
                                        </p>
                                        <div className="text-end">
                                            <button
                                                className="btn btn-sm btn-outline-primary me-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#editModal"
                                                onClick={() =>
                                                    handleOpenBannerModal(index)
                                                }
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => {
                                                    const updated =
                                                        bannerAnimations.filter(
                                                            (_, i) =>
                                                                i !== index,
                                                        );
                                                    setBannerAnimations(
                                                        updated,
                                                    );
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    <hr />

                    {/* ---------------- Featured Vehicles ---------------- */}
                    <Row className="mb-5">
                        <Col
                            xs="12"
                            className="d-flex justify-content-between align-items-center mb-3"
                        >
                            <h3 className="text-primary">Featured Vehicles</h3>
                            <button
                                className="btn btn-sm btn-success"
                                onClick={() =>
                                    handleOpenFeaturedVehicleModal(null)
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#editModal"
                            >
                                + Add Vehicle
                            </button>
                        </Col>

                        {featuredVehicles.map((vehicle, index) => (
                            <Col md="4" key={index} className="mb-3">
                                <div className="card h-100">
                                    <img
                                        src={vehicle.imageUrl || ""}
                                        style={{
                                            height: 200,
                                            objectFit: "contain",
                                        }}
                                    />
                                    <div className="card-body">
                                        <h6>{vehicle.title || "No Title"}</h6>
                                        <p className="text-muted small">
                                            {vehicle.subTitle}
                                        </p>
                                        <div className="text-end">
                                            <button
                                                className="btn btn-sm btn-outline-primary me-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#editModal"
                                                onClick={() =>
                                                    handleOpenFeaturedVehicleModal(
                                                        index,
                                                    )
                                                }
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => {
                                                    const updated =
                                                        featuredVehicles.filter(
                                                            (_, i) =>
                                                                i !== index,
                                                        );
                                                    setFeaturedVehicles(
                                                        updated,
                                                    );
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    <hr />

                    {/* ---------------- Info Cards ---------------- */}
                    <Row className="mb-5">
                        <Col xs="12">
                            <h3 className="text-primary">Info Cards</h3>
                        </Col>

                        <Col md="6" className="mb-3">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5>Info Card 1</h5>
                                </div>
                                <div className="card-body">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Title
                                        </label>
                                        <input
                                            className="form-control"
                                            value={infoCard1.title || ""}
                                            onChange={(e) =>
                                                setInfoCard1({
                                                    ...infoCard1,
                                                    title: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Content
                                        </label>
                                        <textarea
                                            className="form-control"
                                            value={infoCard1.content || ""}
                                            onChange={(e) =>
                                                setInfoCard1({
                                                    ...infoCard1,
                                                    content: e.target.value,
                                                })
                                            }
                                            rows={3}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Link
                                        </label>
                                        <input
                                            className="form-control"
                                            value={infoCard1.link || ""}
                                            onChange={(e) =>
                                                setInfoCard1({
                                                    ...infoCard1,
                                                    link: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Image
                                        </label>
                                        {infoCard1.imageUrl && (
                                            <img
                                                src={infoCard1.imageUrl}
                                                style={{
                                                    width: "100%",
                                                    maxHeight: 150,
                                                    objectFit: "contain",
                                                }}
                                                className="mb-2"
                                            />
                                        )}
                                        <button
                                            className="btn btn-secondary btn-sm m-2"
                                            onClick={() =>
                                                fileUploadRefInfoCard1.current.click()
                                            }
                                            disabled={uploadingInfoCard1}
                                        >
                                            {uploadingInfoCard1
                                                ? "Uploading..."
                                                : "Upload Image"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col md="6" className="mb-3">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5>Info Card 2</h5>
                                </div>
                                <div className="card-body">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Title
                                        </label>
                                        <input
                                            className="form-control"
                                            value={infoCard2.title || ""}
                                            onChange={(e) =>
                                                setInfoCard2({
                                                    ...infoCard2,
                                                    title: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Content
                                        </label>
                                        <textarea
                                            className="form-control"
                                            value={infoCard2.content || ""}
                                            onChange={(e) =>
                                                setInfoCard2({
                                                    ...infoCard2,
                                                    content: e.target.value,
                                                })
                                            }
                                            rows={3}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Link
                                        </label>
                                        <input
                                            className="form-control"
                                            value={infoCard2.link || ""}
                                            onChange={(e) =>
                                                setInfoCard2({
                                                    ...infoCard2,
                                                    link: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Image
                                        </label>
                                        {infoCard2.imageUrl && (
                                            <img
                                                src={infoCard2.imageUrl}
                                                style={{
                                                    width: "100%",
                                                    maxHeight: 150,
                                                    objectFit: "contain",
                                                }}
                                                className="mb-2"
                                            />
                                        )}
                                        <button
                                            className="btn btn-secondary btn-sm m-2"
                                            onClick={() =>
                                                fileUploadRefInfoCard2.current.click()
                                            }
                                            disabled={uploadingInfoCard2}
                                        >
                                            {uploadingInfoCard2
                                                ? "Uploading..."
                                                : "Upload Image"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <hr />

                    {/* ---------------- Featured Services ---------------- */}
                    <Row className="mb-5">
                        <Col
                            xs="12"
                            className="d-flex justify-content-between align-items-center mb-3"
                        >
                            <h3 className="text-primary">Featured Services</h3>
                            <button
                                className="btn btn-sm btn-success"
                                onClick={() =>
                                    handleOpenFeaturedServiceModal(null)
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#editModal"
                            >
                                + Add Service
                            </button>
                        </Col>

                        {featuredServices.map((service, index) => (
                            <Col md="4" key={index} className="mb-3">
                                <div className="card h-100">
                                    <img
                                        src={service.imageUrl || ""}
                                        style={{
                                            height: 150,
                                            objectFit: "contain",
                                        }}
                                    />
                                    <div className="card-body">
                                        <h6>{service.title || "No Title"}</h6>
                                        <p className="text-muted small">
                                            {service.subTitle}
                                        </p>
                                        <div className="text-end">
                                            <button
                                                className="btn btn-sm btn-outline-primary me-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#editModal"
                                                onClick={() =>
                                                    handleOpenFeaturedServiceModal(
                                                        index,
                                                    )
                                                }
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => {
                                                    const updated =
                                                        featuredServices.filter(
                                                            (_, i) =>
                                                                i !== index,
                                                        );
                                                    setFeaturedServices(
                                                        updated,
                                                    );
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    <hr />

                    {/* ---------------- WhatsApp Section ---------------- */}
                    <Row className="mb-5">
                        <Col
                            xs="12"
                            className="d-flex justify-content-between align-items-center mb-3"
                        >
                            <h3 className="text-primary">WhatsApp</h3>
                            <button
                                className="btn btn-sm btn-success"
                                onClick={() =>
                                    handleOpenWhatsAppChatModal(null)
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#editModal"
                            >
                                + Add Chat
                            </button>
                        </Col>

                        <Col md="12" className="mb-3">
                            <label className="form-label">WhatsApp Title</label>
                            <input
                                className="form-control"
                                value={whatsAppTitle}
                                onChange={(e) =>
                                    setWhatsAppTitle(e.target.value)
                                }
                            />
                        </Col>

                        {whatsAppChats.map((chat, index) => (
                            <Col md="6" key={index} className="mb-3">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center mb-3">
                                            <img
                                                src={chat.profileUrl || ""}
                                                alt="Profile"
                                                style={{
                                                    width: 50,
                                                    height: 50,
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                                className="me-3"
                                            />
                                            <div>
                                                <h6 className="mb-0">
                                                    {chat.name || "No Name"}
                                                </h6>
                                                <span
                                                    className={`badge ${chat.available ? "bg-success" : "bg-secondary"}`}
                                                >
                                                    {chat.available
                                                        ? "Available"
                                                        : "Busy"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="text-end">
                                            <button
                                                className="btn btn-sm btn-outline-primary me-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#editModal"
                                                onClick={() =>
                                                    handleOpenWhatsAppChatModal(
                                                        index,
                                                    )
                                                }
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => {
                                                    const updated =
                                                        whatsAppChats.filter(
                                                            (_, i) =>
                                                                i !== index,
                                                        );
                                                    setWhatsAppChats(updated);
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    <hr />

                    {/* ---------------- Contacts ---------------- */}
                    <Row className="mb-5">
                        <Col xs="12">
                            <h3 className="text-primary">Contacts</h3>
                        </Col>

                        {[
                            ["Email", email, setEmail],
                            ["Phone", phoneNumber, setPhoneNumber],
                            ["Facebook", facebookLink, setFacebookLink],
                            ["Tiktok", tiktokLink, setTiktokLink],
                            ["Instagram", instagramLink, setInstagramLink],
                            ["LinkedIn", linkedInLink, setLinkedInLink],
                        ].map(([label, value, setter]: any) => (
                            <Col md="6" key={label} className="mb-3">
                                <label className="form-label">{label}</label>
                                <input
                                    className="form-control"
                                    value={value}
                                    onChange={(e) => setter(e.target.value)}
                                />
                            </Col>
                        ))}
                    </Row>

                    <hr />

                    <Row className="mb-5">
                        <Col md="6">
                            <label className="form-label">Copyright Text</label>
                            <input
                                className="form-control"
                                value={copyRightText}
                                onChange={(e) =>
                                    setCopyRightText(e.target.value)
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            )}

            {/* ---------------- Edit Modal ---------------- */}
            <div className="modal fade" id="editModal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>
                                {isAddingNew ? "Add New " : "Edit "}
                                {editModalType === "banner"
                                    ? "Banner"
                                    : editModalType === "featuredVehicle"
                                      ? "Featured Vehicle"
                                      : editModalType === "featuredService"
                                        ? "Featured Service"
                                        : editModalType === "testimonial"
                                          ? "Testimonial"
                                          : "WhatsApp Chat"}
                            </h5>
                        </div>
                        <div className="modal-body">
                            {/* Banner Modal */}
                            {editModalType === "banner" && (
                                <>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Title
                                                </label>
                                                <input
                                                    className="form-control"
                                                    value={
                                                        bannerData.title || ""
                                                    }
                                                    onChange={(e) =>
                                                        setBannerData({
                                                            ...bannerData,
                                                            title: e.target
                                                                .value,
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Subtitle
                                                </label>
                                                <input
                                                    className="form-control"
                                                    value={
                                                        bannerData.subTitle ||
                                                        ""
                                                    }
                                                    onChange={(e) =>
                                                        setBannerData({
                                                            ...bannerData,
                                                            subTitle:
                                                                e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Content
                                        </label>
                                        <textarea
                                            className="form-control"
                                            value={bannerData.content || ""}
                                            onChange={(e) =>
                                                setBannerData({
                                                    ...bannerData,
                                                    content: e.target.value,
                                                })
                                            }
                                            rows={3}
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Desktop Image
                                                </label>
                                                {bannerData.imageUrl && (
                                                    <img
                                                        src={
                                                            bannerData.imageUrl
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: 150,
                                                            objectFit:
                                                                "contain",
                                                        }}
                                                        className="mb-2"
                                                    />
                                                )}
                                                <button
                                                    className="btn btn-secondary btn-sm m-2"
                                                    onClick={() =>
                                                        fileUploadRef.current.click()
                                                    }
                                                    disabled={uploading}
                                                >
                                                    {uploading
                                                        ? "Uploading..."
                                                        : "Upload Desktop Image"}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Mobile Image
                                                </label>
                                                {bannerData.imageUrlMobile && (
                                                    <img
                                                        src={
                                                            bannerData.imageUrlMobile
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: 150,
                                                            objectFit:
                                                                "contain",
                                                        }}
                                                        className="mb-2"
                                                    />
                                                )}
                                                <button
                                                    className="btn btn-secondary btn-sm m-2"
                                                    onClick={() =>
                                                        fileUploadRefMobile.current.click()
                                                    }
                                                    disabled={uploadingMobile}
                                                >
                                                    {uploadingMobile
                                                        ? "Uploading..."
                                                        : "Upload Mobile Image"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Odoo Variant ID
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={
                                                bannerData.vehicleVariantOdooId ||
                                                ""
                                            }
                                            onChange={(e) =>
                                                setBannerData({
                                                    ...bannerData,
                                                    vehicleVariantOdooId: e
                                                        .target.value
                                                        ? Number(e.target.value)
                                                        : null,
                                                })
                                            }
                                        />
                                        {isOdooIdChecked && (
                                            <small
                                                className={
                                                    isOdooIdValid
                                                        ? "text-success"
                                                        : "text-danger"
                                                }
                                            >
                                                {isOdooIdValid
                                                    ? "Valid Odoo ID"
                                                    : "Invalid Odoo ID"}
                                            </small>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Link
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={bannerData.link || ""}
                                            onChange={(e) =>
                                                setBannerData({
                                                    ...bannerData,
                                                    link:
                                                        e.target.value || null,
                                                })
                                            }
                                        />
                                    </div>
                                </>
                            )}

                            {/* Featured Vehicle Modal */}
                            {editModalType === "featuredVehicle" && (
                                <>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Desktop Image
                                                </label>
                                                {featuredVehicleData.imageUrl && (
                                                    <img
                                                        src={
                                                            featuredVehicleData.imageUrl
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: 150,
                                                            objectFit:
                                                                "contain",
                                                        }}
                                                        className="mb-2"
                                                    />
                                                )}
                                                <button
                                                    className="btn btn-secondary btn-sm m-2"
                                                    onClick={() =>
                                                        fileUploadRefFeaturedVehicle.current.click()
                                                    }
                                                    disabled={
                                                        uploadingFeaturedVehicle
                                                    }
                                                >
                                                    {uploading
                                                        ? "Uploading..."
                                                        : "Upload Desktop Image"}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Mobile Image
                                                </label>
                                                {featuredVehicleData.imageUrlMobile && (
                                                    <img
                                                        src={
                                                            featuredVehicleData.imageUrlMobile
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: 150,
                                                            objectFit:
                                                                "contain",
                                                        }}
                                                        className="mb-2"
                                                    />
                                                )}
                                                <button
                                                    className="btn btn-secondary btn-sm m-2"
                                                    onClick={() =>
                                                        fileUploadRefFeaturedVehicleMobile.current.click()
                                                    }
                                                    disabled={
                                                        uploadingFeaturedVehicleMobile
                                                    }
                                                >
                                                    {uploadingFeaturedVehicleMobile
                                                        ? "Uploading..."
                                                        : "Upload Mobile Image"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Vehicle Type
                                        </label>
                                        <input
                                            className="form-control"
                                            value={
                                                featuredVehicleData.vehicleType ||
                                                ""
                                            }
                                            onChange={(e) =>
                                                setFeaturedVehicleData({
                                                    ...featuredVehicleData,
                                                    vehicleType: e.target.value,
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Title
                                        </label>
                                        <input
                                            className="form-control"
                                            value={
                                                featuredVehicleData.title || ""
                                            }
                                            onChange={(e) =>
                                                setFeaturedVehicleData({
                                                    ...featuredVehicleData,
                                                    title: e.target.value,
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Subtitle
                                        </label>
                                        <input
                                            className="form-control"
                                            value={
                                                featuredVehicleData.subTitle ||
                                                ""
                                            }
                                            onChange={(e) =>
                                                setFeaturedVehicleData({
                                                    ...featuredVehicleData,
                                                    subTitle: e.target.value,
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Link
                                        </label>
                                        <input
                                            className="form-control"
                                            value={
                                                featuredVehicleData.link || ""
                                            }
                                            onChange={(e) =>
                                                setFeaturedVehicleData({
                                                    ...featuredVehicleData,
                                                    link: e.target.value,
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Link 2
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={
                                                featuredVehicleData.link2 || ""
                                            }
                                            onChange={(e) =>
                                                setFeaturedVehicleData({
                                                    ...featuredVehicleData,
                                                    link2:
                                                        e.target.value || null,
                                                })
                                            }
                                        />
                                    </div>
                                </>
                            )}

                            {/* Featured Service Modal */}
                            {editModalType === "featuredService" && (
                                <>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Image
                                        </label>
                                        {featuredServiceData.imageUrl && (
                                            <img
                                                src={
                                                    featuredServiceData.imageUrl
                                                }
                                                style={{
                                                    width: "100%",
                                                    maxHeight: 200,
                                                    objectFit: "contain",
                                                }}
                                                className="mb-2"
                                            />
                                        )}
                                        <button
                                            className="btn btn-secondary btn-sm m-2"
                                            onClick={() =>
                                                fileUploadRefFeaturedService.current.click()
                                            }
                                            disabled={uploadingFeaturedService}
                                        >
                                            {uploadingFeaturedService
                                                ? "Uploading..."
                                                : "Upload Image"}
                                        </button>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Title
                                        </label>
                                        <input
                                            className="form-control"
                                            value={
                                                featuredServiceData.title || ""
                                            }
                                            onChange={(e) =>
                                                setFeaturedServiceData({
                                                    ...featuredServiceData,
                                                    title: e.target.value,
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Subtitle
                                        </label>
                                        <input
                                            className="form-control"
                                            value={
                                                featuredServiceData.subTitle ||
                                                ""
                                            }
                                            onChange={(e) =>
                                                setFeaturedServiceData({
                                                    ...featuredServiceData,
                                                    subTitle: e.target.value,
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Link
                                        </label>
                                        <input
                                            className="form-control"
                                            value={
                                                featuredServiceData.link || ""
                                            }
                                            onChange={(e) =>
                                                setFeaturedServiceData({
                                                    ...featuredServiceData,
                                                    link: e.target.value,
                                                })
                                            }
                                        />
                                    </div>
                                </>
                            )}

                            {/* WhatsApp Chat Modal */}
                            {editModalType === "whatsAppChat" && (
                                <>
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Profile Image
                                        </label>
                                        {whatsAppChatData.profileUrl && (
                                            <img
                                                src={
                                                    whatsAppChatData.profileUrl
                                                }
                                                style={{
                                                    width: 100,
                                                    height: 100,
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                                className="mb-2 d-block"
                                            />
                                        )}
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() =>
                                                fileUploadRefWhatsAppProfile.current.click()
                                            }
                                            disabled={uploadingWhatsAppProfile}
                                        >
                                            {uploadingWhatsAppProfile
                                                ? "Uploading..."
                                                : "Upload Profile Image"}
                                        </button>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Name
                                        </label>
                                        <input
                                            className="form-control"
                                            value={whatsAppChatData.name || ""}
                                            onChange={(e) =>
                                                setWhatsAppChatData({
                                                    ...whatsAppChatData,
                                                    name: e.target.value,
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="mb-3 form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={
                                                whatsAppChatData.available ||
                                                false
                                            }
                                            onChange={(e) =>
                                                setWhatsAppChatData({
                                                    ...whatsAppChatData,
                                                    available: e.target.checked,
                                                })
                                            }
                                        />
                                        <label className="form-check-label">
                                            Available
                                        </label>
                                    </div>
                                </>
                            )}

                            {isFileSizeLarge && (
                                <p className="text-danger mt-2">
                                    Max size 10MB
                                </p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                                onClick={handleCloseModal}
                            >
                                Close
                            </button>
                            <button
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleSaveModal}
                            >
                                {isAddingNew ? "Add" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Hidden file inputs */}
            <input
                type="file"
                ref={fileUploadRef}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "banner")}
            />
            <input
                type="file"
                ref={fileUploadRefMobile}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "bannerMobile")}
            />
            <input
                type="file"
                ref={fileUploadRefFeaturedVehicle}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "featuredVehicle")}
            />
            <input
                type="file"
                ref={fileUploadRefFeaturedVehicleMobile}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "featuredVehicleMobile")}
            />
            <input
                type="file"
                ref={fileUploadRefFeaturedService}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "featuredService")}
            />
            <input
                type="file"
                ref={fileUploadRefInfoCard1}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "infoCard1")}
            />
            <input
                type="file"
                ref={fileUploadRefInfoCard2}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "infoCard2")}
            />
            <input
                type="file"
                ref={fileUploadRefComparePhoto}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "comparePhoto")}
            />
            <input
                type="file"
                ref={fileUploadRefWhatsAppProfile}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, "whatsAppProfile")}
            />
        </div>
    );
};

export default CMSEdit;
